import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Profile, getProfile } from '../../lib/profile';
import { useNavigate } from 'react-router-dom';
import { ProfilePage } from './ProfilePage';

export function UserProfile() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [profile, setProfile] = useState<Profile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (user) {
      loadProfile();
    }
  }, [user]);

  const loadProfile = async () => {
    if (!user) return;
    try {
      const data = await getProfile(user.id);
      setProfile(data);
    } catch (error) {
      console.error('Error loading profile:', error);
      setError('Fehler beim Laden des Profils');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-text-secondary">Laden...</div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-text-secondary">Profil nicht gefunden</div>
      </div>
    );
  }

  return (
    <ProfilePage 
      profile={profile} 
      isOwnProfile={true} 
      onNavigateBack={() => navigate(-1)} 
    />
  );
}